import { useEffect } from 'react';

export type NativeEventHandler = {
  name: string;
  callback: ((event: CustomEvent) => void) | ((event: MessageEvent) => void);
  listen: Window | Document;
};

const useNativeEventListener = (
  events: NativeEventHandler | NativeEventHandler[]
): void => {
  useEffect(() => {
    if (Array.isArray(events)) {
      events.forEach((event: NativeEventHandler) => {
        event.listen.addEventListener(
          event.name,
          event.callback as EventListener
        );
      });
    } else {
      events.listen.addEventListener(
        events.name,
        events.callback as EventListener
      );
    }
    return () => {
      if (Array.isArray(events)) {
        events.forEach((event: NativeEventHandler) => {
          event.listen.removeEventListener(
            event.name,
            event.callback as EventListener
          );
        });
      } else {
        events.listen.removeEventListener(
          events.name,
          events.callback as EventListener
        );
      }
    };
  }, []);
};

export { useNativeEventListener };
